module.exports = __webpack_public_path__ + "static/img/bg.56d8961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/bg.png
// module id = 2SLS
// module chunks = 2